import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { appConstants } from '../../constants/app.constants';
@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: false
})
export class PageNotFoundComponent implements OnInit {
  isLoggedIn: Boolean = false;
  constructor(private cookieService: CookieService) { }

  ngOnInit(): void {
    this.isLoggedIn = this.cookieService.check(appConstants.LOGGED_IN);
  }

}
